import { View } from "react-native";
import { radii } from "../theme/tokens";

type Segment = {
  value: number;
  color: string;
};

type Props = {
  segments: Segment[];
  height?: number;
  backgroundColor?: string;
};

export function SegmentedBar({
  segments,
  height = 6,
  backgroundColor = "#F0EBE5",
}: Props) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  if (total === 0) return null;

  return (
    <View
      style={{
        height,
        borderRadius: radii.full,
        backgroundColor,
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      {segments.map((segment, index) => {
        const widthPercent = (segment.value / total) * 100;
        if (widthPercent <= 0) return null;
        return (
          <View
            key={index}
            style={{
              width: `${widthPercent}%`,
              height: "100%",
              backgroundColor: segment.color,
            }}
          />
        );
      })}
    </View>
  );
}
